const fontFamily = {
    '& *': {
        fontFamily: 'Inter, Montserrat, Helvetica, arial, sans-serif !important'
    },
    fontFamily: 'Inter, Montserrat, Helvetica, arial, sans-serif !important'
}
export default {
    h1: {
        ...fontFamily,
        fontWeight: 600,
        fontSize: '60px',
        lineHeight: '70px',
        letterSpacing: '-1px'
    },
    h2: {
        ...fontFamily,
        fontWeight: 600,
        fontSize: '44px',
        lineHeight: '52px',
        letterSpacing: '-1.5px'
    },
    h3: {
        ...fontFamily,
        fontSize: '36px',
        fontWeight: 600,
        lineHeight: '44px',
        letterSpacing: '-0.3px'
    },
    h4: {
        ...fontFamily,
        fontSize: '30px',
        fontWeight: 600,
        lineHeight: '38px',
        letterSpacing: '-0.3px'
    },
    h5: {
        ...fontFamily,
        fontSize: '24px',
        fontWeight: 600,
        lineHeight: '34px',
        letterSpacing: '-0.2px'
    },
    h6: {
        ...fontFamily,
        fontSize: '20px',
        fontWeight: 600,
        lineHeight: '28px',
        letterSpacing: '-0.2px'
    },
    h7: {
        ...fontFamily,
        fontSize: '18px',
        fontWeight: 600,
        lineHeight: '26px',
        letterSpacing: '-0.2px'
    },
    h8: {
        ...fontFamily,
        fontSize: '18px',
        fontWeight: 400,
        lineHeight: '26px',
        letterSpacing: '-0.2px'
    },
    subtitle1: {
        ...fontFamily,
        fontSize: '15px',
        fontWeight: 600,
        lineHeight: '23px',
        letterSpacing: '-0.1px'
    },
    subtitle2: {
        ...fontFamily,
        fontSize: '13px',
        fontWeight: 600,
        lineHeight: '21px'
    },
    subtitle3: {
        ...fontFamily,
        fontSize: '12px',
        fontWeight: 600,
        lineHeight: '19px'
    },
    body1: {
        ...fontFamily,
        fontSize: '15px',
        fontWeight: 400,
        lineHeight: '23px'
    },
    body1heavy: {
        ...fontFamily,
        fontSize: '15px',
        fontWeight: 700,
        lineHeight: '23px'
    },
    body2: {
        ...fontFamily,
        fontSize: '13px',
        fontWeight: 400,
        lineHeight: '21px',
        letterSpacing: '-0.1px'
    },
    body2heavy: {
        ...fontFamily,
        fontSize: '13px',
        fontWeight: 700,
        lineHeight: '21px'
    },
    body3: {
        ...fontFamily,
        fontSize: '12px',
        fontWeight: 500,
        lineHeight: '18px'
    },
    body3heavy: {
        ...fontFamily,
        fontSize: '12px',
        fontWeight: 700,
        lineHeight: '18px',
        letterSpacing: '0.1px'
    },
    body4: {
        ...fontFamily,
        fontSize: '10.5px',
        fontWeight: 500,
        lineHeight: '16px'
    },
    body4heavy: {
        ...fontFamily,
        fontSize: '10.5px',
        fontWeight: 700,
        lineHeight: '16px',
        letterSpacing: '0.2px'
    },
    buttonLarge: {
        ...fontFamily,
        fontSize: '14px',
        fontWeight: 600,
        lineHeight: '18px',
        letterSpacing: '-0.1px'
    },
    buttonMedium: {
        ...fontFamily,
        fontSize: '12.5px',
        fontWeight: 600,
        lineHeight: '15px'
    },
    buttonSmall: {
        ...fontFamily,
        fontSize: '11px',
        fontWeight: 600,
        lineHeight: '16px'
    },
    captionLight: {
        ...fontFamily,
        fontSize: '11px',
        fontWeight: 500,
        lineHeight: '16px'
    },
    captionHeavy: {
        ...fontFamily,
        fontSize: '11px',
        fontWeight: 600,
        lineHeight: '16px'
    },
    overline: {
        ...fontFamily,
        fontSize: '10.5px',
        fontWeight: 700,
        lineHeight: '12px',
        letterSpacing: '0.4px'
    },
    serial: {
        ...fontFamily,
        fontSize: '12px',
        fontWeight: 500,
        lineHeight: '12px',
        letterSpacing: '1px'
    },
    label: {
        ...fontFamily,
        fontSize: '10px',
        fontWeight: 600,
        lineHeight: '12px',
        letterSpacing: '0.1px'
    },
    helperText: {
        ...fontFamily,
        fontSize: '10.5px',
        fontWeight: 500,
        lineHeight: '14px'
    },
    avatarXlarge: {
        ...fontFamily,
        fontSize: '56px',
        fontWeight: 500,
        lineHeight: '56px',
        letterSpacing: -'2px'
    },
    avatarLarge: {
        ...fontFamily,
        fontSize: '36px',
        fontWeight: 500,
        lineHeight: '36px',
        letterSpacing: -'1px'
    },
    avatarMedium: {
        ...fontFamily,
        fontSize: '20px',
        fontWeight: 500,
        lineHeight: '20px',
        letterSpacing: '-0.5px'
    },
    avatarSmall: {
        ...fontFamily,
        fontSize: '17px',
        fontWeight: 500,
        lineHeight: '17px',
        letterSpacing: '-0.4px'
    }
}
